import { useEffect } from 'react';

const useEventListeners = (
    event: { name: string; callback: (e: CustomEventInit) => void },
    bound: [unknown] | [],
    namespace = '',
) => {
    useEffect(() => {
        if (event) {
            if (window) {
                window.addEventListener(`${namespace}${event.name}`, event.callback);
            }

            return () => {
                if (window) {
                    window.removeEventListener(`${namespace}${event.name}`, event.callback);
                }
            };
        }
    }, bound);
};

export default useEventListeners;
